import { createSlice } from "@reduxjs/toolkit";

const workspaceSlice = createSlice({
  name: "workspace",
  initialState: { workspaceChanged: false },
  reducers: {
    change: (state) => {
      return { workspaceChanged: !state.workspaceChanged };
    },
  },
});

export const { change } = workspaceSlice.actions;

export default workspaceSlice.reducer;
